import watch from 'redux-watch'

import { setCart } from '../storage/cart'
import { AppStore } from 'src/client/store'

export function watchCart(store: AppStore) {
  store.subscribe(watch(store.getState, 'cart')(setCart))
}
